import React, { FC, useContext } from "react";
import Header from "@app/pippa/components/header";
import Main from "@app/pippa/components/main";
import UserInput from "@app/pippa/components/userInput";
import Disclaimer from "@app/pippa/components/disclaimer";
import { DialogsContext, EventsContext } from "@app/pippa/provider";
import "./chat.scss";

const Chat: FC = () => {
  const { acknowledgementDialog, closeWidgetDialog, messageFeedbackDialog } =
    useContext(DialogsContext);
  const {
    eventsProviderState: { isInputHidden },
  } = useContext(EventsContext);
  const shouldShowInputSection = !isInputHidden;

  return (
    <article className="pippa-widget-chat__container">
      <Header />
      <Main />
      {shouldShowInputSection && (
        <>
          <UserInput />
          <Disclaimer />
        </>
      )}
      {acknowledgementDialog.getDialog()}
      {closeWidgetDialog.getDialog()}
      {messageFeedbackDialog.getDialog()}
    </article>
  );
};

export default Chat;
